<template lang="pug">
extends ../../../../prototype/src/pug/layout/section_column_gray_top
include ../../../../prototype/src/pug/abstracts/mixin.pug
block main
	.markdown.passo_a_passo__text_block.passo_a_passo__text_block--top
		h1 
			strong Vamos descobrir 
			|qual modelo de Certificado Digital você precisa?

	.passo_a_passo__breadcrumb
		.passo_a_passo__breadcrumb--step(v-bind:class="{ enabled: this.target != null && this.reason == null && this.device == null }") 1
		.passo_a_passo__breadcrumb--step(v-bind:class="{ enabled: this.target != null && this.reason != null && this.device == null }") 2
		.passo_a_passo__breadcrumb--step(v-bind:class="{ enabled: this.target != null && this.reason != null && this.device != null }") 3

	.passo_a_passo__section_title
		strong 1.
		|Para quem é o Certificado Digital?
	.panel__group
		CertificadosItem('v-for'='item in fields' :icon="item.icon", :title="item.title", :description="item.description", :isActive="item.id == target", :route="'/certificados/' + item.id")

	.passo_a_passo__section_title(v-if="reasons")
		strong 2.
		|Qual o motivo do uso?
	.panel__group(v-if="reasons")
		CertificadosItem('v-for'='item in reasons.choices' :description="item.description", :isActive="item.id == reason", :route="'/certificados/' + target + '/' + item.id")

	.passo_a_passo__section_title(v-if="showDevices")
		strong 3.
		|Qual dispositivo pretende usar?
	.panel__group(v-if="devices")
		CertificadosItem('v-for'='item in devices.choices' :description="item.description", :isActive="item.id == device", :route="'/certificados/' + target + '/' + reason + '/' + item.id")

	.passo_a_passo__section_title(v-if="showLinks")
		strong.normal O melhor certificado Digital para você é:

	.panel__group(v-if="showLinks")
		CertificadosItemVertical('v-if'='links' 'v-for'='item in links.choices' :icon="item.icon" :title="item.title" :description="item.description", :link_loja="item.url" :link_saiba_mais="item.mais")
		CertificadosItemVertical('v-if'='devices' 'v-for'='item in devices.items' :icon="item.icon" :title="item.title" :description="item.description", :link_loja="item.url" :link_saiba_mais="item.mais")

	.passo_a_passo__aplicacao__group(v-if="devices.aplicacoes && showLinks")
		.passo_a_passo__aplicacao__title Algumas situações em que você pode usar o certificado digital:
		.passo_a_passo__aplicacao__list
			AplicacaoItem('v-if'='devices', 'v-for'='item in devices.aplicacoes' :label="item")

block variables
	- var id = "certificados"
</template>

<script>
import data from "@/assets/escolhas.json";
import AplicacaoItem from "@/components/certificados/aplicacao_item.vue";
import CertificadosItem from "@/components/certificados/certificados_item.vue";
import CertificadosItemVertical from "@/components/certificados/certificados_item_vertical.vue";

export default {
	name: "CertificadoComponent",
	components: {
		CertificadosItem,
		CertificadosItemVertical,
		AplicacaoItem,
	},
	data() {
		return {
			fields: data,
		};
	},
	computed: {
		reasons: function () {
			if (this.target) {
				for (var i = 0; i < this.fields.length; i++) {
					if (this.fields[i].id == this.target) {
						return this.fields[i];
					}
				}
			}

			return null;
		},
		devices: function () {
			if (this.reason && this.reasons) {
				for (
					var i = 0;
					i < this.reasons.choices.length;
					i++
				) {
					if (
						this.reasons.choices[i].id ==
						this.reason
					) {
						return this.reasons.choices[i];
					}
				}
			}

			return {
				choices: [],
				items: [],
			};
		},
		showDevices: function () {
			if (!this.devices) return false;

			if (this.devices.choices.length > 0) {
				return true;
			}

			return false;
		},
		links: function () {
			if (this.device && this.devices) {
				for (
					var i = 0;
					i < this.devices.choices.length;
					i++
				) {
					if (
						this.devices.choices[i].id ==
						this.device
					) {
						return this.devices.choices[i];
					}
				}
			}

			return { choices: [] };
		},
		showLinks: function () {
			console.log("links.choices", this.devices);
			console.log("devices.items", this.devices.items);

			if (this.links) {
				if (this.links.choices) {
					if (this.links.choices.length > 0) {
						return true;
					}
				}
			}

			if (this.devices) {
				if (this.devices.items) {
					return this.devices.items.length > 0;
				}
			}

			return false;
		},
		target: function () {
			return this.$route.params.target;
		},
		reason: function () {
			return this.$route.params.reason;
		},
		device: function () {
			return this.$route.params.device;
		},
	},
};
</script>
